import React from 'react'; 
import { connect } from 'react-redux'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { LoadingComponent } from '../../utils/ui'
import { AdmsRepository, ModelViews } from '../../redux';
import { AssetListViewBase } from '../containers';
import ViewsProxy from '../models/ViewsProxy';


/**
 * Спциальный объект, проксирующие выбор записи каталога
 * Основная задача - загрузить необходимые данные и сделать выбор элемента каталога
 */
class ElementProxy extends React.Component {

  state = {
    loaded: false, 			  //Флаг загрузки, необходимый данных
  }


  static getDerivedStateFromProps(props, state) {
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    this.loadADMS()
  }

  componentWillUnmount(){
    this.props.onUnLoadItems()
  }

  loadADMS() {
    this.setState({loaded: false})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание
      this.props.onLoadItems(),
    ])
    .then ((response) =>{
      this.setState({loaded: true, error: undefined});
    })
    .catch(e => { 
      this.setState({loaded: true, error: e});
    });
  }
  onSelected (IRI){
    this.setState({asset: IRI});
  }

  render() {
    console.log(this);
    let { loaded, asset } = this.state;
    if (!loaded) return <LoadingComponent />;
    if (asset){
      const asset_json = {id: asset};
      return <ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={undefined} filter={["tree", "table"]}/>
    }
    return (
      <AssetListViewBase  {...this.props} onSelected={IRI => this.onSelected(IRI)}/>
      )
  }
}
 
//Представление информации о Wiki статьях
export default connect(
  null,
  dispatch => ({
    onLoadItems(){
      return dispatch(AdmsRepository.PUSH());
    },
    onUnLoadItems(){
      return dispatch(AdmsRepository.POP());
    },
  })
)(ElementProxy)

